import { templateKey, title } from './fields'

const image = { label: "Image", name: "image", widget: "image" }

const quote = { label: "Quote", name: "quote", widget: "text" }

const newsDate = { label: "Date", name: "date", widget: "text" }
const newsTitle = { label: "Title", name: "title", widget: "text" }
const newsDescription = { label: "Description", name: "description", widget: "text" }
const newsImage = { label: "Image", name: "image", widget: "image" }
const newsRelatedFile = { label: "Related File", name: "newsRelatedFile", widget: "file", required: false }
const news = {
    label: "News",
    name: "news",
    widget: "list",
    fields: [newsDate, newsTitle, newsDescription, newsImage, newsRelatedFile]
}

const landingFields = [templateKey, title, image, quote, news]

export const landingEN = {
    file: "src/pages/index.en.md",
    label: "Landing Page English",
    name: "index english",
    fields: landingFields
}
export const landingDE = {
    file: "src/pages/index.de.md",
    label: "Landing Page German",
    name: "index german",
    fields: landingFields
}